interface State {
  storages: any[];
  services: any[];
  storageCommissions: Record<string, any>;
  serviceCommissions: Record<string, any>;
}

export const teamMemberCommissionReducer = (
  state: State = {
    storages: [],
    services: [],
    storageCommissions: {},
    serviceCommissions: {},
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_COMMISSION_STORAGES":
      return {
        ...state,
        storages: action.payload || [],
      };
    case "GET_COMMISSION_SERVICES":
      return {
        ...state,
        services: action.page && action.page > 1 ? [...state.services, ...(action.payload || [])] : (action.payload || []),
      };
    case "UPDATE_STORAGE_COMMISSIONS":
      return {
        ...state,
        storageCommissions: { ...state.storageCommissions, ...action.payload },
      };
    case "UPDATE_SERVICE_COMMISSIONS":
      return {
        ...state,
        serviceCommissions: { ...state.serviceCommissions, ...action.payload },
      };
    case "CLEAR_COMMISSIONS":
      return {
        ...state,
        storageCommissions: {},
        serviceCommissions: {},
      };
    default:
      return state;
  }
};
